import React from "react";
import Micropalette from "../../../../Micropalette";
import { API, PrintRecord } from "../../../../BlakeData";

import "./style/main.scss"
// import {ReactComponent as SelectedIcon} from "./selected-icon-with-shadow.svg";
// import {ReactComponent as SelectedIconHover} from "./selected-icon.svg";
// import {ReactComponent as CloseIcon} from "./close-icon.svg";

import {ReactComponent as SelectedIcon} from "./checkmark_nocolor.svg";
import {ReactComponent as CloseIcon} from "./close_nocolor.svg";


/**
 * Just a helper to make the main render function simpler
 * @param props 
 */
// function ThumbnailTitle(props: {
//     selected: boolean,
//     text: string
// }) {
//     return (
//         <div className="meta-text">
//             {props.selected ? props.text : "  "}&nbsp;
//     </div>

//     )
// }

/**
 * Just a helper to make the main render function simpler.
 * @param props 
 */
function ThumbnailImage(props: {
    selected: boolean;
    print: PrintRecord;
}) {
    return (<div>
        {/* <div className="hover-screen" />
        <div className="thumbnail-button-tray">
            <div className="thumbnail-button toggle-button">
                {props.selected ? <CloseIcon style={{fill:"white"}}/> : "√"}
            </div>
        </div> */}
        <img
            alt={props.print.id}
            //src={`${process.env.PUBLIC_URL}/img/${props.print.id}.100.jpg`}
            src={API.getThumbnailURL(props.print)}
        />
    </div>)


}

interface ThumbailCarouselItemProps {
    itemWidth?: number
    print: PrintRecord;
    onToggled: () => void;
    selected: boolean;
    index: number;
    label?: string;
    // handleDimensions?:(opts:{width:number, height:number})=>void
}

export function ThumbnailCarouselItem(props: ThumbailCarouselItemProps) {
    // const [label, setLabel] = useState<string | undefined>();

    const palettes = API.makeSwatchArray([props.print]);
    const itemWidth = props.itemWidth || 60;

    // if (typeof label !== "string") {
    //     API.getEdition(props.print.editionID).then((e: EditionRecord) => {

    //         setLabel(e.archiveCopyID)

    //     })
    //     .catch(()=>{setLabel(props.print.editionID)})
    // }

    return (
        <div className={`ThumbnailCarouselItem ${props.selected ? "selected" : "unselected"}`} key={props.index}>
            <div style={{ width: itemWidth }}
                className={`hover-box item  ${props.selected ? "selected" : "unselected"}`}
                onClick={props.onToggled}
            >
                {/* <ThumbnailTitle
                    selected={props.selected}
                    text={label || ""}
                /> */}
                <div className="icon selection-indicator"><SelectedIcon/> </div>
                <div className="icon close-icon"><CloseIcon/></div>


                <Micropalette
                    height={itemWidth}
                    paletteWidth={20}
                    padding={0}
                    id={`thumb-micropalette-${props.print.id}`}
                    palettes={palettes}
                    vertical
                />

                <ThumbnailImage
                    selected={props.selected}
                    print={props.print}
                />

            </div>

        </div>
    )

}